import React, { useEffect, useState } from 'react';
import { TabMenu } from '../tabber/Tabber.component';
import './header.scss';
import PlayerStats from './PlayerStats.component';

const Header = ({ data, version }) => {
	return (
		<>
			<div className="stats-message">
				<div>VERSION : Alpha, {version}</div>
				<div className={`status ${data.server ? 'online' : 'offline'}`}>
					SERVER STATUS : <span>{`${data.server ? 'ONLINE' : 'OFFLINE'}`}</span>
				</div>
			</div>
			<img className="logo" src="/assets/pr_logo_white.svg" />
			<TabMenu />
			<PlayerStats data={data} />
		</>
	);
};

export default Header;
